import { giveScore } from "../../Diverse/Rating.js";
import { createSlider } from "../../Helpers/tools";

window.modalHotelData = null;

document.addEventListener("DOMContentLoaded", function () {
  createSlider({
    selector: ".js-itinerary-columns-slider",
    slidesPerView: "auto",
    spaceBetweenInMobile: 16,
    spaceBetweenInDesktop: 24,
    nextEl: ".js-itinerary-columns-slider-next",
    prevEl: ".js-itinerary-columns-slider-prev",
  });

  let options = {
    TotalNum: 5,
    getScore: false,
    setScore: true,
    fontIcon: true,
    htmlelement: false,
    writeScore: false,
    getAndSet: false,
    iclasses: {
      unselect: "0",
      select: "icon-star-yellow",
      halfIcon: "1",
    },
  };

  document.querySelectorAll(".getRating").forEach(function (element) {
    giveScore(element, options);
  });

  function setFilterValue({ value, prevValue = null, checked }) {
    let newValue = null;

    if (checked) {
      newValue = prevValue ? `${prevValue},${value}` : value;
    } else {
      let format = prevValue.indexOf(value) === 0 ? `${value},` : `,${value}`;
      if (prevValue.length === 1) format = `${value}`;

      newValue = prevValue.replace(format, "");
    }

    return newValue;
  }

  async function checkBoxFilter() {
    let dataType = this.getAttribute("data-type");
    let prevValue = null;

    if (window.hotelDataModel.filter != null) {
      prevValue = window.hotelDataModel.filter[dataType];
    }

    let newValue = await setFilterValue({
      value: this.getAttribute("value"),
      prevValue,
      checked: this.checked,
    });

    if (newValue === "") {
      delete window.hotelDataModel.filter[dataType];
    } else {
      window.hotelDataModel.filter = { ...{ [dataType]: newValue } };
    }
    openPopModal.call(this);
  }

  function tabActivation(selectedItem, activeClassName) {
    document
      .querySelectorAll(`.${activeClassName}`)
      .forEach(function (element) {
        element.previousElementSibling.removeAttribute("checked");
      });
    selectedItem.previousElementSibling.setAttribute("checked", "checked");
  }

  const setSortValue = (value) => {
    window.hotelDataModel.sort = value;
  };

  function sort() {
    tabActivation(this, "js-hotel-list-sort-item");
    setSortValue(this.getAttribute("sort-value"));
    openPopModal.call(this);
  }

  async function saveOldSearchBoxData(selectedItem = null) {
    window.mainHotelData = deepCopy(window.hotelDataModel);

    window.hotelDataModel = window.modalHotelData
      ? deepCopy(window.modalHotelData)
      : deepCopy(window.hotelDataModel);

    window.hotelDataModel.id = selectedItem
      ? selectedItem.getAttribute("data-id")
      : window.mainHotelData.id;
    window.hotelDataModel.slug = selectedItem
      ? selectedItem.getAttribute("data-slug")
      : window.mainHotelData.slug;
    window.hotelDataModel.sort = selectedItem
      ? selectedItem.getAttribute("sort-value")
      : window.mainHotelData.sort;
    window.hotelDataModel.filter = window.mainHotelData.filter;
  }

  function restoreOldSearchBoxData() {
    window.modalHotelData = deepCopy(window.hotelDataModel);
    window.hotelDataModel = deepCopy(window.mainHotelData);
  }

  function setDestinationTitle(selectedItem) {
    const title = selectedItem.getAttribute("data-title")
    const id = selectedItem.getAttribute("data-id")

    const modalDestinationTitle = title
      ? title
      : window.mainHotelData.hotelTitle;

    window.destinationInput.inputValue = modalDestinationTitle;
    window.destinationInput.hotel.id = id ? id : window.mainHotelData.id ;
  }

  function openPopModal() {
    document.body.classList.toggle("no-scroll");

    saveOldSearchBoxData(this).then(() => {
      setDestinationTitle(this);
    });

    const popup = document.querySelector(".js-hotels-popup");
    if (popup) {
      popup.classList.add("fade");
      popup.classList.add("show-modal");
    }
  }

  function closePopupModal(e) {
    let popupTarget = e.target;

    if (window.innerWidth < 992) {
      popupTarget = e.target.parentElement;
    }

    if (
      e.target.classList.contains("js-close-popup-modal") ||
      popupTarget.classList.contains("js-hotels-popup")
    ) {
      document.body.classList.toggle("no-scroll");

      restoreOldSearchBoxData();

      const errorMessage = document.querySelector(".error-message");
      if (errorMessage) {
        errorMessage.remove();
      }

      const popup = document.querySelector(".js-hotels-popup");
      if (popup) {
        popup.classList.remove("show-modal");
        popup.classList.remove("fade");
      }
    }
  }

  // Init popup title
  const popupTitle = document.querySelector(".js-hotels-popup-title");
  if (popupTitle) {
    popupTitle.textContent = window.searchInitialize.search.destinations.title;
  }

  document.querySelectorAll(".check-box").forEach(function (element) {
    element.addEventListener("change", checkBoxFilter);
  });

  document
    .querySelectorAll(".js-hotel-list-sort-item")
    .forEach(function (element) {
      element.addEventListener("click", sort);
    });

  document
    .querySelectorAll(".js-hotel-list-no-link")
    .forEach(function (element) {
      element.addEventListener("click", openPopModal);
    });

  document.querySelectorAll(".js-hotels-popup").forEach(function (element) {
    element.addEventListener("click", closePopupModal);
  });

  document
    .querySelectorAll(".js-table-content-link")
    .forEach(function (element) {
      element.addEventListener("click", function () {
        document
          .querySelectorAll(".js-table-content-link")
          .forEach(function (link) {
            link.classList.remove("active");
          });
        this.classList.add("active");
      });
    });

  window.addEventListener("scroll", function () {
    let links = document.querySelectorAll(".js-table-content-link");
    let items = Array.from(document.querySelectorAll(".js-table-content-item"));

    items.forEach(function (item) {
      let itemOffsetTop = item.getBoundingClientRect().top + window.scrollY;
      let itemHeight = item.offsetHeight;
      let itemId = item.querySelector(".js-table-content-item-title")
        ? item.querySelector(".js-table-content-item-title").id
        : null;

      if (
        itemId &&
        window.scrollY > itemOffsetTop - 62 &&
        window.scrollY < itemHeight + itemOffsetTop
      ) {
        links.forEach(function (link) {
          link.classList.remove("active");
        });

        let activeLink = document.querySelector(
          ".js-table-content-link[href='#" + itemId + "']"
        );
        if (activeLink) {
          activeLink.classList.add("active");
        }
      }
    });
  });
});

function deepCopy(obj) {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  if (obj instanceof Date) {
    return new Date(obj);
  }

  if (obj instanceof Array) {
    let copy = [];
    for (let i = 0; i < obj.length; i++) {
      copy[i] = deepCopy(obj[i]);
    }
    return copy;
  }

  if (obj instanceof Object) {
    let copy = {};
    for (let key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        copy[key] = deepCopy(obj[key]);
      }
    }
    return copy;
  }
}
